var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "search-underlay", on: { click: _vm.unFocus } }),
    _c(
      "div",
      { staticClass: "byor-single-search-wrapper" },
      [
        _c(
          "div",
          {
            staticClass: "search-underlay-close-note",
            on: { click: _vm.unFocus },
          },
          [
            _vm._v("close search "),
            _c("b-icon", { attrs: { icon: "x-circle-fill" } }),
          ],
          1
        ),
        !_vm.searchInitiated
          ? _c(
              "div",
              {
                staticClass: "search-help",
                staticStyle: { "flex-direction": "column" },
              },
              [
                _c(
                  "strong",
                  { staticStyle: { "font-size": "1.2em", color: "#f26822" } },
                  [
                    _vm._v(
                      "Find multi-omic Common Fund data, analyses, and program knowledge."
                    ),
                  ]
                ),
                _c("strong", [
                  _vm._v("With this LLM enhanced search, you can:"),
                ]),
                _c("div", [
                  _vm._v(
                    "Ask about the Common Fund, its Centers, or its Programs."
                  ),
                ]),
                _c("div", [
                  _vm._v("Tell me what you're researching or curious about."),
                ]),
                _c("div", [_vm._v("Just describe what you're looking for.")]),
                _c(
                  "a",
                  {
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        _vm.display_examples = !_vm.display_examples
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(!_vm.display_examples ? "show" : "hide") +
                        " examples"
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    class: { collapsed: !_vm.display_examples },
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      gap: "5px",
                      padding: "10px 20px",
                    },
                  },
                  _vm._l(_vm.exampleQueries, function (example) {
                    return _c(
                      "div",
                      {
                        staticClass: "query-sample",
                        on: {
                          click: function ($event) {
                            return _vm.useExample(example)
                          },
                        },
                      },
                      [_vm._v(_vm._s(example))]
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm.searchInitiated
          ? _c(
              "div",
              { staticClass: "search-results", staticStyle: { gap: "40px" } },
              [
                _vm.llmResults
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          gap: "20px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "grid",
                              gap: "20px",
                              "grid-template-columns": "1fr 1fr",
                            },
                          },
                          [
                            _vm.llmResults.programs
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "search-result-box",
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                      gap: "5px",
                                    },
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v("Suggested CFDE Programs:"),
                                    ]),
                                    _vm._l(
                                      _vm.llmResults.programs,
                                      function (program) {
                                        return _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "column",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "grid",
                                                  "grid-template-columns":
                                                    "1fr 2fr",
                                                  gap: "10px",
                                                },
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(_vm._s(program.name)),
                                                ]),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "justify-content":
                                                        "flex-end",
                                                      gap: "10px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.kcURL(
                                                            `/r/kc_programs?DCC=${program.id}`
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "program snapshot"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm
                                                            .programLinks[
                                                            program.id
                                                          ],
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [_vm._v("data portal")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("div", [
                                              _vm._v(_vm._s(program.reason)),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.llmResults.discovery
                              ? _c(
                                  "div",
                                  { staticClass: "search-result-box" },
                                  [
                                    _c("strong", [
                                      _vm._v("Knowledge Center Discovery: "),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "See evidence-backed hypotheses about the biology behind your research interest:"
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "text-align": "center",
                                          "font-family": "serif",
                                          "font-size": "1.4em",
                                          padding: "10px",
                                          "font-style": "italic",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.llmResults.discovery))]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        " Using pre-computed genetic associations between 6,000 common & rare disease phenotypes and 150,000 gene expression signatures from various CFDE Programs. "
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticStyle: { margin: "10px 0 0" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.kcURL(
                                                `/r/factor_base_reveal?query=${_vm.llmResults.discovery}`
                                              ),
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("mechanism discovery")]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", gap: "20px" } },
                          [
                            _vm.llmResults.gene?.name
                              ? _c(
                                  "div",
                                  { staticClass: "search-result-box" },
                                  [
                                    _c("div", [
                                      _c("strong", [_vm._v("Gene: ")]),
                                      _vm._v(
                                        _vm._s(_vm.llmResults.gene.name) + " "
                                      ),
                                    ]),
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.kcURL(
                                              `/r/kc_entity_gene?gene=${_vm.llmResults.gene.name}`
                                            ),
                                          },
                                        },
                                        [_vm._v("gene info from cfde programs")]
                                      ),
                                    ]),
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.kcURL(
                                              `/r/kc_gene_set_browser?model=cfde&gene=${_vm.llmResults.gene.name}`
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "gene set ↔ phenotype associations"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.kcURL(
                                              `/r/kc_gene_set_browser_gene?model=cfde&gene=${_vm.llmResults.gene.name}`
                                            ),
                                          },
                                        },
                                        [_vm._v("phenotype associations")]
                                      ),
                                    ]),
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.kcURL(
                                              `/r/kc_dge_gene?gene=${_vm.llmResults.gene.name}`
                                            ),
                                          },
                                        },
                                        [_vm._v("tissue associations")]
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.llmResults.phenotype?.name
                              ? _c(
                                  "div",
                                  { staticClass: "search-result-box" },
                                  [
                                    _c("div", [
                                      _c("strong", [_vm._v("Phenotype: ")]),
                                      _vm._v(
                                        _vm._s(_vm.llmResults.phenotype.name) +
                                          " "
                                      ),
                                    ]),
                                    _vm.semanticPhenotypes
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.semanticPhenotypes,
                                            function (item) {
                                              return _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(item.description)
                                                    ),
                                                  ]),
                                                  _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.kcURL(
                                                            `/r/kc_gene_set_browser_phenotype?model=cfde&phenotype=${_vm.llmResults.phenotype.name}`
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "associated cfde gene sets"
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.kcURL(
                                                            `/r/kc_phenotype_x_hs2mouse?phenotype=${_vm.llmResults.phenotype.name}`
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "associated mouse phenotypes"
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm.llmResults.tissue?.name
                              ? _c(
                                  "div",
                                  { staticClass: "search-result-box" },
                                  [
                                    _c("div", [
                                      _c("strong", [_vm._v("Tissue: ")]),
                                      _vm._v(
                                        _vm._s(_vm.llmResults.tissue.name) + " "
                                      ),
                                    ]),
                                    _vm.availableTissues
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.availableTissues,
                                            function (item) {
                                              return _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.label)),
                                                  ]),
                                                  _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.kcURL(
                                                            `/r/kc_dge_tissue?tissue=${item.value}`
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "differential expression by tissue"
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _c("div", [
                                          _vm._v(" no results found "),
                                        ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.llmResults.disease?.name
                              ? _c(
                                  "div",
                                  { staticClass: "search-result-box" },
                                  [
                                    _c("div", [
                                      _c("strong", [_vm._v("Disease: ")]),
                                      _vm._v(
                                        _vm._s(_vm.llmResults.disease.name) +
                                          " "
                                      ),
                                    ]),
                                    _vm.availableDiseases
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.availableDiseases,
                                            function (item) {
                                              return _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.label)),
                                                  ]),
                                                  _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.kcURL(
                                                            `/r/kc_entity_disease?disease=${item.value}`
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "disease info from cfde programs"
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _c("div", [
                                          _vm._v(" no results found "),
                                        ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm.singleSearchMethod == "ss_keyword"
          ? [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.singleSearchParam,
                    expression: "singleSearchParam",
                  },
                ],
                ref: "search",
                staticClass: "form-control byor-single-search",
                attrs: {
                  type: "text",
                  id: "byor_single_search",
                  placeholder: !_vm.hasFocus ? "Click here to begin" : "",
                  autocomplete: "off",
                },
                domProps: { value: _vm.singleSearchParam },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onSearch.apply(null, arguments)
                  },
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.singleSearchParam = $event.target.value
                  },
                },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                  },
                },
                [
                  _vm.singleSearchParam && !_vm.isLoading
                    ? _c(
                        "div",
                        {
                          staticClass: "reset-search",
                          on: {
                            click: function ($event) {
                              return _vm.resetSearch()
                            },
                          },
                        },
                        [
                          _vm._v(" clear search "),
                          _c("b-icon", { attrs: { icon: "backspace-fill" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isLoading
                    ? _c("div", { staticClass: "loading" })
                    : _vm._e(),
                ]
              ),
            ]
          : _vm._e(),
        !!_vm.singleSearchConfig &&
        !!_vm.singleSearchConfig["search by meaning enabled"] &&
        _vm.singleSearchMethod == "ss_meaning"
          ? _c("div", { staticClass: "byor-single-search-results-wrapper" }, [
              _vm.meaningSearchOptions.length > 0 &&
              _vm.meaningSearchOptions[0].value != ""
                ? _c(
                    "div",
                    {
                      staticClass: "byor-single-search-results-groups",
                      staticStyle: { top: "75px" },
                      attrs: { id: "byor_single_search_results" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "byor-ss-results-section ss-meaning-search",
                          attrs: {
                            id: _vm.meaningSearchParam + "_meaning_options",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "byor-ss-results-section-title" },
                            [_vm._v(_vm._s())]
                          ),
                          _vm._l(
                            _vm.meaningSearchOptions,
                            function (item, itemIndex) {
                              return _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "single-search-option",
                                    on: {
                                      mouseover: function ($event) {
                                        return _vm.getVerticalPos(
                                          _vm.meaningSearchParam +
                                            "_meaning_options",
                                          _vm.meaningSearchParam +
                                            "_" +
                                            itemIndex
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.label) +
                                        _vm._s(" (" + item.score + ")") +
                                        " "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "more-options" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "ss-options-wrapper",
                                            attrs: {
                                              id:
                                                _vm.meaningSearchParam +
                                                "_" +
                                                itemIndex,
                                            },
                                          },
                                          _vm._l(
                                            _vm.isParameterActive(
                                              _vm.meaningSearchParam
                                            ).options,
                                            function (option) {
                                              return _c("div", [
                                                _c("span", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "ss-explore",
                                                      attrs: {
                                                        href: option.url
                                                          ? option.url +
                                                            item.value
                                                          : "javascript:;",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option["url label"]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  !!option.url &&
                                                  !!option.sections
                                                    ? _c("span", [
                                                        _vm._v(" | "),
                                                      ])
                                                    : _vm._e(),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "ss-generate-summary",
                                                      attrs: {
                                                        href: "javascript:;",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.generateSummary(
                                                            item.value,
                                                            option[
                                                              "summary id"
                                                            ],
                                                            option[
                                                              "summary label"
                                                            ],
                                                            option.sections
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option[
                                                              "summary label"
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm.meaningSearchOptions.length === 1 &&
                  _vm.meaningSearchOptions[0].value == ""
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "byor-single-search-results-groups",
                        staticStyle: { top: "75px" },
                        attrs: { id: "byor_single_search_results" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "byor-ss-results-section ss-meaning-search",
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "single-search-option" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.meaningSearchOptions[0].label
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            class: !!_vm.summaryPopup
              ? "ss-summary-popup"
              : "ss-summary-popup hidden",
            attrs: { id: "summary_popup" },
          },
          [
            _c(
              "span",
              {
                staticClass: "btn btn-default ss-summary-hide",
                on: {
                  click: function ($event) {
                    _vm.summaryPopup = !_vm.summaryPopup ? true : null
                  },
                },
              },
              [_c("b-icon", { attrs: { icon: "arrow-down-left-square" } })],
              1
            ),
            _c("h4", [_vm._v("Search quick view")]),
            _c(
              "div",
              { staticClass: "summary-content" },
              _vm._l(_vm.summaryAll, function (item) {
                return _c("div", { domProps: { innerHTML: _vm._s(item.data) } })
              }),
              0
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }